import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _sortBy from "lodash/sortBy";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import createQueryHook from '@segment/utils/createQueryHook';
import { createFsCacheProxy } from '@segment/utils/fsCache';
import { useStaticSiteBackend } from '@segment/contexts/staticSiteBackend';

var groupFilters = function groupFilters(types) {
  var groupedFilters = {};
  var filters = types.filter(function (type) {
    var _type$items$validatio, _type$items$validatio2;

    return type.items && ((_type$items$validatio = type.items.validations[0]) === null || _type$items$validatio === void 0 ? void 0 : (_type$items$validatio2 = _type$items$validatio["in"]) === null || _type$items$validatio2 === void 0 ? void 0 : _type$items$validatio2.length) > 0;
  });
  filters.forEach(function (filter) {
    var _items$validations$0$;

    var items = filter.items,
        id = filter.id;
    groupedFilters[id] = {
      title: "Teams",
      items: _sortBy((_items$validations$0$ = items.validations[0]["in"]) === null || _items$validations$0$ === void 0 ? void 0 : _items$validations$0$.map(function (item) {
        return {
          title: item,
          id: "".concat(item.toLowerCase().replace(/\s/g, ""))
        };
      }), function (item) {
        return item.title.toLowerCase();
      })
    };
  });
  return groupedFilters;
};

export var fetchFilters = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(client) {
    var enabled, cachedFetch;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            enabled = Boolean(process.env.ENABLE_FS_CACHE);
            _context.next = 3;
            return createFsCacheProxy(["useCasesFilters"], function () {
              return client.get("/content/contentTypes/useCase").then(function (data) {
                return groupFilters(data);
              });
            }, {
              enabled: enabled
            });

          case 3:
            cachedFetch = _context.sent;
            return _context.abrupt("return", cachedFetch());

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFilters(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var createFiltersQuery = function createFiltersQuery(client) {
  return [["useCases/filtersQuery"], function () {
    return fetchFilters(client);
  }];
};
export var useFiltersQuery = createQueryHook(createFiltersQuery, useStaticSiteBackend, {
  staleTime: Infinity
});